import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"filter\"><path d=\"M18.467 4.222H5.533c-.722 0-1.31.59-1.31 1.311v3.134l4.444 4.444v6.667h2.222l4.444-3.334v-3.333l4.445-4.444V5.533c0-.722-.59-1.31-1.311-1.31m-.356 3.756-3.956 3.955-.488.49v3.188l-3.334 2.5v-5.689l-.489-.489-3.266-3.266h6.533c.611 0 1.111-.5 1.111-1.111H5.89V5.889H18.11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol